import { render, staticRenderFns } from "./UserDropdownSelector.vue?vue&type=template&id=cdbb1824&"
import script from "./UserDropdownSelector.vue?vue&type=script&lang=js&"
export * from "./UserDropdownSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports